import React from 'react';
import { useTranslation } from 'react-i18next';
import { MissingDataParagraph } from './MissingDataParagraph';

export const MissingDataParagraphContainer = ({ ...props }) => {
  const { t } = useTranslation();
  return <MissingDataParagraph t={t} {...props} />;
};
